import CardElementNoPrint from './CardElementNoPrint';

export default CardElementNoPrint;
